import { 
  TITLE_LAYOUT_SCHEMA, 
  SUBTITLE_LAYOUT_SCHEMA, 
  TEXT_LAYOUT_SCHEMA, 
  OBSERVATION_LAYOUT_SCHEMA, 
  BUTTON_LAYOUT_SCHEMA, 
  BG_LAYOUT_SCHEMA 
} from '../common/layout'
import { parseObject } from '../index'

export const LAYOUT_SCHEMA = config => {
  const defaultProps = { id: '', label: '' }
  if (config && typeof config === 'object') {
    if (config.id && typeof config.id === 'string') Object.assign(defaultProps, { id: config.id })
    if (config.label && typeof config.label === 'string') Object.assign(defaultProps, { label: config.label })
  }

  const customValue = (prop) => {
    if (prop && typeof prop === 'object' && !Array.isArray(prop)) return prop
    else return {}
  }

  return {
    id: defaultProps.id,
    label: defaultProps.label,
    default: {color: '#434A54', font: 'Inter'},
    title: parseObject({ schema: TITLE_LAYOUT_SCHEMA(), target: customValue(config.title)}),
    subtitle: parseObject({ schema: SUBTITLE_LAYOUT_SCHEMA(), target: customValue(config.subtitle)}),
    text: parseObject({ schema: TEXT_LAYOUT_SCHEMA(), target: customValue(config.text)}),
    observation: parseObject({ schema: OBSERVATION_LAYOUT_SCHEMA(), target: customValue(config.observation)}),
    button: parseObject({ schema: BUTTON_LAYOUT_SCHEMA(), target: customValue(config.button)}),
    bg: parseObject({ schema: BG_LAYOUT_SCHEMA(), target: customValue(config.bg)}),
  }
}

export const beforeParseContent = target => {
  console.log('parser...')
}

export const LAYOUT_SECTION = config => ({
  schema: LAYOUT_SCHEMA(config),
  beforeParse: beforeParseContent
})
